var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _ellipse, _ellipse2, _path89, _path90, _ellipse3, _ellipse4, _path91;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-bm",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#cf142b",
    d: "M0 0h512v512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#006",
    d: "M0 0h256v256H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M256 0v32l-95 96 95 93.5V256h-33.5L127 162l-93 94H0v-34l93-93.5L0 37V0h31l96 94 93-94z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "m92 162 5.5 17L21 256H0v-1.5zm62-6 27 4 75 73.5V256zM256 0l-96 98-2-22 75-76zM0 .5 96.5 95 67 91 0 24.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M88 0v256h80V0zM0 88v80h256V88z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "M0 104v48h256v-48zM104 0v256h48V0z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M467 146.6v161.6c0 43.1-86.1 57.2-86.1 57.2s-86.5-14-86.5-57.4V146.6H467z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f8f22",
    d: "M467 308.2c0 43.1-86.1 57.2-86.1 57.2s-86.5-14-86.5-57.4c0 0 0-3.5 1.8-5.4 0 0-1 7.1 4.5 12.6 0 0-4.3-7.8 0-15.3 0 0-1.6 9.8 4.4 15.3 0 0-3.3-7.9.4-16.7 0 0-1.8 14.3 4.8 17.3 0 0 1.8-8.4-.9-13.6 0 0 4.6 1.8 4.3 13.8 0 0 1.5-1.8 1.8-10.5 0 0 .3 10 3.6 12.3 0 0 1.2-1-.4-5.5-1.5-4.4.6-6 1-6 0 0-.7 5 3.4 8.8 0 0-1.7-7.9.8-9 0 0-.6 6.7 4.7 8.1 0 0 .4-1.9-.8-4 0 0-1-2.5-.2-4.5 0 0 1.6 6 3.9 7 0 0-1.3-3.6 0-7 0 0 .2 5 4.8 7.1 0 0-3-4-2-8.2l28.8 1.4 14.9.7 44.7-3 7.6-6.7s3.1 4.1-1.7 10.8c0 0 4.7-.8 6.3-8.3 0 0 1.9 4.1-.7 8.8 0 0 5.2-5.4 6-11.3 0 0 2 5.8-3 12 0 0 4.5-1.6 6.4-8.1 0 0 1.5 4-2.8 9.5 0 0 8.1-4.1 8-13 0 0 3.2 4.8-.6 11.6 0 0 4-3.7 4.6-9.3 0 0 2.2 2.5-.3 9.4 0 0 5-4.8 5.9-9.9 0 0 1 4.8-3.3 10.8 0 0 3-.8 5.8-6.6 0 0 .7 2.4-1.8 6.6 0 0 2.7-.5 4.5-5.9 0 0 .4 3.2-.5 6 0 0 2.2-1.3 2.7-7.3 0 0 1.1 1.9 1.1 4.4v.8z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#d40000",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M422.7 214.7s-3 .6-6.9-.6c-3.8-1.2-5.4-.7-6.6 0 0 0 1.6-3.1-2.2-5.6 0 0 1.2 3.2-.5 4.6 0 0-.7.7-1.7-.3 0 0-1.3-1.5-2.7-2.4 0 0 3.2-1.2 2.6-4.5-.6-3.3-2.4-3.6-3.2-4.1a6 6 0 0 0 0 2.4s-3.6-2 1.2-4.7 4-4.4 3-5.8a13.1 13.1 0 0 0-3.5-3.6s1 1.6.7 2.9c-.1 1.2-2.4 2-1.9-.1.5-2.4 0-2 0-4.3 0 0 4.2 1.4 6-2.8 0 0 1.5-4.3-3.8-6.4 0 0 1.3 1.8.7 3 0 0-1.2 2.2-2.5.6-1.3-1.7-2.3-2.2-2.2-4.2 0 0 5 .7 3.6-4.7 0 0-.8 3.6-7.2-1.2 0 0 4.2-4.2 2.5-7.6 0 0-.4-1.5-4.8-.7 0 0 3.8-2.4 2.2-4.5 0 0-.8-1.3-4.5.4 0 0 1.4-2.3-2.2-5 0 0-2.3 1.2-3.5 2.4 0 0-2.4-3-4-4.3 0 0-2.8 1.1-3.5 4.3 0 0-1.4-1.5-4.3-2.4 0 0-1.5 2.8.4 5 0 0-1.4 0-3.9-1.1 0 0-2.9-1.2-2.4 1.1.4 2.4.6 3 1.2 4.2 0 0-6.4-1.5-6.2 2a8.8 8.8 0 0 0 3.1 6.2s-3.6 4.8-6.7 1.2c0 0-1.2 1.2 1.2 4.2 0 0 2.4 2.5.4 4.2 0 0-2.5 2-3.7-2 0 0-4.2 4.1.7 7.2 0 0 3.1 1.8 6.3-1 0 0-1 8-4 6.4 0 0-1.8-1.2 1.4-2.9 0 0-4.8-.6-5.5 4 0 0-.6 3.5 3.6 5 0 0 3.1 1.2-.1 3.6 0 0-2.4 1.7-.9 4.4 0 0 1.8 2.8-2.8 3.2 0 0-2.4 0-3.4-.4 0 0-1 2-.3 4 0 0-2.4-1.7-7.5.2-5.3 2-5 .6-5.3 1.2l-1.5 2.4s2.7 3.6 2.8 3.3l-.6 4 1.5.6 10.7-4.8 11-5.7 9 .4 5.5 1.3 7.3.6 5.4-2.8h7.6l8.3 4.2 9.6 5.7 5 1 3.8-.3v-7.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#d40000",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M335.6 223.7s4.1 2.2 6-.3c0 0 2.2-4.4-2.8-6 0 0 2.7-3.2-.3-6.2 0 0-1.5-1.6-4.1-.5 0 0-1.2-2.3-3.7-2.2 0 0-2.4 0-3.1 2.5 0 0-3.1-1.2-4.8.6 0 0-3 3.2 1 5.8l3 .3 2.8-1.4 3.2.9s-.8 3.2 2.8 6.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#64b4d1",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M429 216.1a6.7 6.7 0 0 1 6.8 3.8c2.7 6.2-3 9.6-3 9.6.4 1.3.5 3.2.5 3.2 7.9 1 6.5 9.8 6.5 9.8l-2.7-2.2c-4.5-1.8-9.3 2.2-12.6 8.6-3.3 6.6-1.8 9.5-1.2 17.3.6 7.7 13.1 12.4 13.1 12.4l-9.8 25c-3.8 10-11.9 5.9-14.3 3.7-2.2-2-2.8-.8-3.9 0-1.2 1 5.3 6-6.6 10.8-11.6 4.7-13.7 8.3-15.7 9.5-1.9 1.2-10 .5-10.7-.6-1-1-.5-1-3.6-2.9-3-1.7-8.1-3.5-13.7-6.2s-5.5-6.2-5.4-6.9c0-.7 2-6.5-4.6-1.9-6.6 4.7-12.2-2.2-12.2-2.2-1.2-1.7-6.8-16.4-6.8-16.4a92.4 92.4 0 0 0-4.3-12s-.3.8 4.6-2c4.7-2.7 7-7.3 8.7-11.9 1.6-4.6 0-12.5-.6-14-.6-1.6-4.2-8.9-8.7-10.4-4.5-1.6-7.6 2.4-7.6 2.4s-1.3-9 6.6-10c0 0 0-1.8.5-3.1 0 0-5.6-3.4-3-9.6 0 0 1.8-4.3 6.8-3.8l-1.2 2.4s-1.2 12.6 17.3 4.2c18.5-8.6 17.9-10.2 28.6-4.8l7.6-.1s11.1-5.3 14.7-3c3.6 2.3 16.3 9.4 16.3 9.4s12.4 4.7 15-4z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#00247d",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "M373.1 271s-.6-3.9-1.2-6.4c0 0-1.4-3.9 1-6.8l2.8-3.3s1.8-2.4 4-2.7c0 0 2.4 0 2.5-.5.2-.5 2.7-4.5 8.6 0 0 0 1.7-3 4.7-3.6 0 0 3-.8 4.6 1.4 0 0 3.4-2.6 6.4 1.7 0 0 4-2.4 7.2 2.3 0 0 3.9-2 6.4 2.1 2.5 4.3 2 6 2 6l2 6.8 6.5 8-15.3 5.8h-6.9l-13.7 3.6-24.3 1.9-6.7-8 9.5-8.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#d40000",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M352.6 311.5s-3.6.1-5.5 1.2c-1.8.8-3.2 1.8-5.3 3.2 0 0-1.1 1.3-5.3.5 0 0-7.1-1.7-7.1 4 0 0-8.9.6-5.3 8.3 0 0 2.4 6 7.4 1.8 0 0-3.2 4.5 3 6.3 0 0 4.4 1.2 5.7-3.5 0 0 .7-1.8-1-4 0 0 2.2-.4 3.6-2.7 0 0-4.5 5.8.5 8 0 0 6.3 1.5 6.7-5 0 0-.6-3.2 1.9-4.3 0 0 5-1.2 7.1-6.6 0 0-7.1-3.9-6.4-7.2zM337.9 254s-5.6-2.5-8.3 0c0 0-3.6-2.2-7.5 0 0 0-3.7 2.4-6.3 5.2 0 0-1.8 1.5-1.2 6.4 0 0 1 3.5.4 5.1 0 0-1.2-.2-3.7 2.8 0 0-3 3.5-6 .3 0 0 1 4.6 6.2 3.8 0 0-2.5 2-.4 7 0 0 1.7 3.6-1 8.2 0 0 4.6-1.8 4.5-7.2 0 0-.5-3.6 1-6 0 0-1.5 2.2 1.6 7.1 0 0 2.4 3.6.5 7.2 0 0 4.4-1.6 4-7-.5-5.4-3-3.2-1.4-8.2 0 0 .5 2.6 1.8 4a7.2 7.2 0 0 1 2.4 7s2.6-3.4 2-6.8a13.1 13.1 0 0 0-1.3-4.4l8.3-4.8 4.3-7.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "M325.2 275.5s-3.6-.2-4-3m-6.2-1.8s1.2 0 2.4 1.2c0 0 .7 1.2 2 1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M330.3 265.2s-1.8 0-2.9-.8c0 0-1-.7-1.5.4 0 0-1 1.6.7 2.3 0 0 2.3 1.2-1.2 3.4 0 0 4-1.6 2.4-3.6 0 0-1.8-1.2-1.2-1.7 0 0 .2-.4 1 0 .7.6 2.1.4 2.7 0z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#784421",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m385 275 2-.6-13.9-48h-.5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 328.3s-3.2-1.9-6 .3c0 0 .4-1.2 2.5-1.7 0 0 1.1-3.2 4.2-2.9 0 0-1.3 1.6-3 2.8 0 0 1.9.2 2.5 1.5z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#64b4d1",
    stroke: "#00247d",
    strokeMiterlimit: 2.6,
    strokeWidth: 1.2,
    d: "M327 335.8s-5.2-3.2-2.3-8.7c0 0 .8-1.5 2.4-1.2 0 0 3.2 1 .7 5.5 0 0-1.3 2.9-.7 4.5zm10.6 5.3s-7.4-3.4-5.1-9.2c0 0 .7-2 2.3-1.8 0 0 2.9.2 2.3 4 0 0-.8 3.6.5 7z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M336 319.6s-2.2 1.7-3 2.8c0 0-1-1.2-2.2-1.8 0 0 1.4-.3 2.1.3 0 0 1.2-1 3.1-1.3z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#64b4d1",
    stroke: "#00247d",
    strokeMiterlimit: 2.6,
    strokeWidth: 1.2,
    d: "M342.6 339.6s6-1.4 4.8-7.5c0 0-.6-2.6-3-2.2 0 0-3 .8-1.1 4.6 0 0 1.2 2.6-.7 5.1z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5ce00",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 1.2,
    d: "m369 212.7 5.7 1.9s5.3 2.3 12.2 0l5.3-2-3.6 5.4v2.9l2.2 3.2s-1.4.6-5.4-2c0 0-4.4-3.4-9.7 0 0 0-3 2-5.3 2l3.4-3.8-1.3-3.5-3.6-4.3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M344.9 332.5s.2-.4 0-.5l-.5.2s-.6 1 0 2.4c0 0 .5.9.2 1.8l.1.4s.3-.1.3-.4c0 0 .3-.8-.3-1.8 0 0-.6-1.4.2-2.1z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#d40000",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M425.3 223.7s-4.1 2.2-6-.3c0 0-2-4.4 3-6 0 0-2.8-3.2 0-6.2 0 0 1.6-1.6 4.2-.5 0 0 1.2-2.3 3.7-2.2 0 0 2.4 0 3.1 2.5 0 0 3.2-1.2 5 .6 0 0 2.8 3.2-1.3 5.8l-2.8.3-2.9-1.4-3.1.9s.8 3.2-2.9 6.5z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5ce00",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 1.2,
    d: "M392.2 220.4s0 .8-.8 1c0 0-1 .3-1.6-.9v-.3c0-.5-.2-2 1.4-3.3 0 0 2.7-2.1 7.7.5a192 192 0 0 0 14.8 7.5s3 1.6 7.8 1.8c0 0 6.6.5 9.3-4.1 0 0 2.2-3.5 0-5.8 0 0-.8-1-2.2-.8a3 3 0 0 0-1.8 1.2s-1.1 1.4 0 2.5c0 0 1.6 1 2.2-1 0 .2.5 1.7-.3 2.9 0 0-4 6-15-.1l-14.2-8.1s-7.2-3.7-11.6 2.1c0 0-3.5 4.8 1 7.9 0 0 3.4 2 5.4-1.2 0 0 1.8-3.1-1-4.4 0 0-2.3-1.2-3.3 1.2s1.8 3 2 1.3c0 0 0-.4.3 0z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#e4cb5e",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 1.2,
    d: "M335.3 245.2v-9c0-.8 0-1.2 1.2-2.2 1-.8 2.2-2.3 3.7 1.7 0 0 3.2-3.5 4.3-4 0 0 1.9-1.5 3.2.7 0 0 1.7-2.6 3-3.2 0 0 3.2-2 3.3 4.2l2.5-2.4s2-1.5 4.2.7c0 0 3.6 3.6 4 4.6 0 0 .9 1 1 2.7 0 0 0 2 1 3 0 0 1.2 1 2.2 1.2 0 0 2.5.1 3.6 2.6 0 0 .4-.5 1.7 11.2v21.5l-14.4 17.1-23.2-6.6-9.2-3.9-2.1-6.6 9-5.9 4.7-13-1.4-9.3-2.3-5.2z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#784421",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m399 256.4 1.2-1.5 2.5-2s4 10.4 4.2 12.7v3.2s6 1.6 7.1 10.7l-5 9.2-7.7-4.4-2.3-1.5v-26.3z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M325.7 328.4s.2-.3 0-.6l-.5.4s-1.6 1.7-.3 4.4c0 0 0 .4.4.2 0 0 .2 0 0-.3 0 0-1.2-2.4.4-4z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "M349 326.6s.1-.8-.3-1.6c0 0-.4-.6-.3-1.5M354 233.4s0 2.3.7 4c.6 1.6 3 4.5 3 5.9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#d40000",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M408.4 311.5s3.6.1 5.5 1.2c1.9.8 3.3 1.8 5.5 3.2 0 0 1 1.3 5.1.5 0 0 7.3-1.7 7.3 4 0 0 8.7.6 5.1 8.3 0 0-2.4 6-7.4 1.8 0 0 3.2 4.5-3 6.3 0 0-4.4 1.2-5.7-3.5 0 0-.7-1.8 1-4 0 0-2-.4-3.5-2.7 0 0 4.5 5.8-.5 8 0 0-6.3 1.5-6.7-5 0 0 .5-3.2-1.9-4.3 0 0-5-1.2-7.2-6.6 0 0 7.1-3.9 6.4-7.2z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "m351.2 243.4 6 47.8m-4.6-47.9 6.7 44.6m-5.5-44.8 7.7 44.2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#784421",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m366 283.5 2.1-.7-14-48h-.4z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "m358 241.3 14.2 35.5m-15-35 13.5 37"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M335 337.6s-1.7-1.5-1.5-4.3c0 0 0-.6-.2-.7 0 0-.4-.1-.4.6 0 0-.4 2.9 1.6 4.5 0 0 .1.3.3.2 0 0 .3 0 0-.3z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "m358.8 240.8 14.3 32.4M355 242.8l9 43.7"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5ce00",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 1.2,
    d: "M427.4 275c-6.4-3.6-7.8-11.4-7.8-11.4a24.6 24.6 0 0 1 1.7-14.3c4-8.6 11-10.3 11-10.3s-6.8 4.8-8.8 11.2c0 0-1.4 5.5-.5 10.7.8 5.5.4 4.1 1.7 8.3l2.7 6z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#784421",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m400 254.7-26.5 8.5-1.5 12c-6.3 9.1-19.2 10.7-19.2 10.7l10 10.7 19.1 4 10.2-7.8 9.2-8.4c-1-4.5-.5-11.2-.5-11.2 0-1.2.5-3.8.5-3.8s-1.6-10.7-1.2-14.5z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "M372.4 272.2s17.5-5.5 28-10m-36.5 20s22-4 37.4-12.8l5.6-3.8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "m406.9 268.8-6 4.4s-24.6 11.2-43.3 11.6m43.2-3.6s-18.9 9.7-29.6 9.8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#d40000",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M423.2 254s5.6-2.5 8.3 0c0 0 3.6-2.2 7.7 0 0 0 3.5 2.4 6.2 5.2 0 0 1.8 1.5 1.2 6.4 0 0-1 3.5-.4 5.1 0 0 1.2-.2 3.6 2.8 0 0 3.2 3.5 6 .3 0 0-.9 4.6-6 3.8 0 0 2.4 2 .2 7 0 0-1.5 3.6 1 8.2 0 0-4.6-1.8-4.3-7.2 0 0 .3-3.6-1-6 0 0 1.3 2.2-1.8 7.1 0 0-2.3 3.6-.3 7.2 0 0-4.6-1.6-4-7 .3-5.4 3-3.2 1.2-8.2 0 0-.3 2.6-1.6 4a7.2 7.2 0 0 0-2.4 7s-2.6-3.4-2-6.8c.6-3.5 1.1-4.4 1.1-4.4l-8.3-4.8-4.2-7.5z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#00247d",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "M328 284.4s.8-3.7 4.2-2.4c0 0 1.2-6 7.8-6.2 6.4-.2 6.8 6.4 6.8 6.8 0 0 2-2.8 5-2.5 0 0 5.6-.3 3.7 8.5l1 1.2s4-9.9 12.7-7.4c0 0 8.3 2.6 3 10.7 0 0 4.1 5.5 7.6 5 3.6-.5 6.7-1.6 10.1-7.8 3.6-6.2 11.7-7.2 13.7-6.8 2 .3 3.7 1.8 4 3.2 0 0 4.4-14.3 19.9-12.2l6.2 3.3 2.4 1-3.6 10L424 308l-6.5 2-6.8-3.9-2.4 1.2-.1 5.9-9 6.4-6.2 2.5-6.8 4.8-1.6 4.2s-3.7-1.7-8 0l-1.5-3.6-4-3.7-15.5-7.4-2.8-9-2.8-1.3-3.2 3.6-4.6.6-6.9-4.8-7.5-21z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 1.2,
    d: "M395.5 214s-6-.2-5.7 6"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5ce00",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 1.2,
    d: "M434.4 279.3c-10.3-3.2-13.1-14.3-13.1-14.3a25.5 25.5 0 0 1 1.3-15.5c4.8-11 12.6-11 12.6-11a4 4 0 0 1 4.6 3.2c.3 2.4-1.3 3.3-1.3 3.3-2.8 1.5-4.6-.5-4.6-.5-1.2-1.6-.2-2.9-.2-2.9.7-1 2-.4 2-.4 1.2.2 1 1.6 1 1.6s.3-1.6-1.2-1.8c0 0-3.2-.7-6.8 3.8 0 0-4.8 6.1-4.8 14.1 0 0-.6 14.8 14.8 18.6 0 0-1.7 2.4-4.7 11.1 0 0-3.3 11.2-6.4 17.3 0 0-4.3 8.6-13.8 5.1 0 0-5.6-2.5-5.6-6.5 0 0-.4-3.8 3-4 0 0 3.3-.3 3.3 2.5 0 0 0 3-3.6 2.4 0 0-1.2-.3-1-1.5 0 0 .2-1.2 1.7-.6 1.6.6 0 0 0-.1 0 0-.6-.3-1.2 0 0 0-.6 0-.6 1 0 0 0 .6.8 1.1l1.6.2s1 2 3.1 2.7a8 8 0 0 0 7-1.2 10.7 10.7 0 0 0 3-4.3 113.3 113.3 0 0 0 5.3-13.5s1.8-5.7 3.3-8.7z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5ce00",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 1.2,
    d: "M405.3 307.4s2-.2 2 1.5c0 0 0 2.4-3.2 1.9 0 0-3-.6-1.9-4 0 0 .7-2.3 3.6-2 0 0 2.7 0 4 3.8 0 0 .9 3.3-.8 6-1.8 3-6.2 5-8.3 6 0 0-8.8 3.3-11.4 5.3 0 0-4 2.9-2.1 5.6 0 0 .7 1.1 1.6 1.1 0 0 1.2 0 1.4-1.2 0 0 0 .7-.8 1 0 0-.8.4-1.6-.3 0 0-1-1-.3-2.4 0 0 1.1-1.6 3.6-.6 0 0 2 1.1 1.2 3.3 0 0-.8 2.1-3.3 2 0 0-2 0-3.3-1.2-1.9-2.1-2-6-.2-8 0 0 1.6-2.1 4.8-3.6l9-3.5a18 18 0 0 0 6.4-4.1s1.3-1.4 1.8-4c0 0 .3-2-.9-2.4l-1.2-.3z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 1.2,
    d: "M405.5 307.4s2.2-.4 3.5 2.2c0 0 .7 1.5.8 2.5m.8-9s-2.2.3-1.1 3.4c1.2 2.9 3 3.7 3.6 4.2"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5ce00",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 1.2,
    d: "M369 220.4s0 .8.9 1c0 0 .8.2 1.3-.9l.1-.3c0-.5.3-2-1.3-3.3 0 0-2.7-2.1-7.7.5 0 0-4 2-6.7 3.6 0 0-7.2 3.8-8.1 4 0 0-3.1 1.6-7.9 1.8 0 0-6.6.5-9.3-4.1 0 0-2.1-3.5 0-5.8 0 0 .8-1 2.3-.8.6.1 1.2.4 1.8 1.2 0 0 1 1.4-.2 2.5 0 0-1.5 1-2.1-1 0 .2-.4 1.6.5 3 0 0 3.9 5.9 14.8-.3l14.3-8s7.1-3.7 11.5 2c0 0 3.5 4.8-1 8 0 0-3.3 2-5.4-1.2 0 0-1.7-3 1-4.4 0 0 2.3-1.2 3.4 1.2 1 2.4-2 3-2.1 1.3 0 0 0-.4-.2 0zm-35.2 54.7c6.3-3.5 7.7-11.5 7.7-11.5 1.4-8-1.7-14.3-1.7-14.3-4-8.6-11-10.3-11-10.3s6.9 4.8 8.8 11.2c0 0 1.5 5.5.6 10.7-.9 5.5-.5 4.1-1.8 8.3z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 1.2,
    d: "M365.7 214s6-.2 5.6 6"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5ce00",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 1.2,
    d: "M326.6 279.3c10.4-3.2 13.1-14.3 13.1-14.3a25.5 25.5 0 0 0-1.2-15.5c-4.7-11-12.6-11-12.6-11a4 4 0 0 0-4.5 3.2c-.4 2.4 1.3 3.3 1.3 3.3 2.7 1.5 4.5-.5 4.5-.5 1.2-1.6.2-2.9.2-2.9-.7-1-2-.4-2-.4-1.2.2-1 1.6-1 1.6s-.3-1.6 1.3-1.8c0 0 3.2-.7 6.8 3.8 0 0 4.7 6.1 4.7 14.1 0 0 .6 14.8-14.8 18.6 0 0 1.7 2.4 4.7 11.1 0 0 3.3 11.2 6.5 17.3 0 0 4.2 8.6 13.8 5.1 0 0 5.6-2.5 5.6-6.5 0 0 .3-3.8-3-4 0 0-3.4-.3-3.4 2.5 0 0 0 3 3.6 2.4 0 0 1.2-.3 1-1.5 0 0-.1-1.2-1.7-.6-1.5.6 0 0 0-.1 0 0 .6-.3 1.2 0 0 0 .6 0 .6 1 0 0 0 .6-.7 1.1l-1.6.2s-1 2-3.2 2.7a7.5 7.5 0 0 1-7-1.2 10.7 10.7 0 0 1-3-4.3 113.5 113.5 0 0 1-5.3-13.5s-1.7-5.7-3.2-8.7l-.6-1.2z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5ce00",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 1.2,
    d: "M355.8 307.4s-1.9-.2-1.9 1.5c0 0 0 2.4 3.1 1.9 0 0 3-.6 2-4 0 0-.8-2.3-3.7-2 0 0-2.7 0-3.9 3.8 0 0-1 3.3.7 6 1.8 3 6.2 5 8.4 6 0 0 8.7 3.3 11.3 5.3 0 0 4 2.9 2.1 5.6 0 0-.6 1.1-1.6 1.1 0 0-1.2 0-1.3-1.2 0 0 0 .7.7 1 0 0 .8.4 1.6-.3 0 0 1-1 .3-2.4 0 0-1-1.6-3.5-.6 0 0-2.1 1.1-1.2 3.3 0 0 .8 2.1 3.3 2 0 0 1.9 0 3.2-1.2 1.9-2.1 2-6 .3-8 0 0-1.6-2.1-4.7-3.6-2-.6-5.5-2.1-9.1-3.5a16.5 16.5 0 0 1-6.4-4.1s-1.3-1.4-1.8-4c0 0-.4-2 .8-2.4l1.2-.3h.1z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 1.2,
    d: "M355.6 307.4s-2.2-.4-3.5 2.2c0 0-.7 1.5-.8 2.5m-.7-9s2.1.3 1 3.4c-1.1 2.9-3 3.7-3.5 4.2m27.4-91.1s5.1-3.3 10.4.3M346.2 251.2s.7-3-2.7-8l-3.2-7.5m7.4-3.3 2.4 6.6 2.9 6.8"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "M348.5 254.3s2 2.1 1.8 5.6m-8-7.9s2 1 1.8 6.8c0 0 0 4 3 6.2m-5.2 1.4s6.6-.7 7.1 3.5c0 0 0 4 2.4 4.3 0 0 3.3.3 4 3.6M344 271s1.2 1.7 2.4 2.6m6.2-7s1.7 2.7 2 4.1m5.4-35s1.5 2.1 3 3m3.2 9.6s3.3 1.6 2.9 10c0 0-.5 5 1 7.7"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#784421",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m350.5 242.6.3.8s6 .3 9.2-3.8l-.4-.8s-5.2-.3-9 3.8z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "M372 274.5s20.7-6 28.7-9.6"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#784421",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "m369.9 236.5-.2-.6 10-4 .3.8z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "m370.7 236.1 6.8 33.3m-5.6-33.6 7.8 33m-6.5-33.6 8.5 32.9m-5.1-34.1 11.5 24.6m-10-25 12.3 24.2M379.2 233l13.3 24.3M377 269.6l5.3-1.6m-9.2-1.6s15.3-4.5 27-9.2M372.9 268s19.4-5 27.2-8.8m-21.3 24.6 1 3.3 2.8-1-.9-3.1m5-1.3 1 3 2.7-.9-1-3m-16-17.6-.2-4.2 25.5-7.7 1.4 3.6m-16 .8 1.3 3.8m7.5-6.4 1.7 3.6m.4-4.3 1.6 3.3m.5-4 1.5 3.6m0-4 2.9-1.6 1.2 3.1m-2.6-2.3 1.4 3.3"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00247d",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "M336.9 299.1s-5-5.1 0-10c0 0-5.5-2.6-4.7-7m13.6 21s-5.2.7-3.7-9.4c0 0-2.1 4-2.9 6a4.7 4.7 0 0 0 2 5.4c1 .6 5.6 1.8 7-1.2m-8.2-16.2s-2.2 1.9-.6 5.4m2.7-5s.2 3.5 2 5.4m-.4-6.7s0 4 2.8 6.6m-1.4-8s0 4.5 3.3 7.4m13.5-.7s1.7-3.9 5.2-3.6c0 0-1.6.8-1.6 2.5 0 0-.3 3 2.8 3.2 0 0 2.5.4 3.9-1"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00247d",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "M370.5 309.1s-9-4.2-8-10.1c0 0 .4-3.6 4-5.4m-2 3.8s-.8 2.5 1 4.3m1-6s-1.1 2.8.8 4.8m1.4-6.3s-1.3 2.4.2 4.5m-8.3 11s4.8 4.3 8.6 4.3m-10.2-2.9s4.6 3.6 7.4 4.2m-9-3.2s5.6 4.9 9 5.2m13.7 4.6s-5.4 3-1.1 6.2m-2.4-9.4 9-4.6m-6.8 6.2s9.1-5.5 11.7-6.7m-7 7.2s7.7-5.2 12-7.5m-6.9 7.1s5.4-4 10.5-7.1m1.8-5.1s-2.6-3.9-11.2 0c0 0 3.2-2.9 9.4-5.2m8.6-16.3s.7 3.1 0 5"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#00247d",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "M393.9 301.7s1.7-2.6 6.3-4c0 0 1.2 3 4.7 2.5 0 0 5.3-1.1 3.6-7 0 0-1-4.2-7.1-4.7m18-7.3s6.2 1.2 6 6.1c0 0 .7 7.6-7.3 9m6.5-12s1.7-3.7 5.5-5.2m-4.5-2.2s1.6 2.8 2.7 3.1m-3.6-1 2 2.5m-2.6-.5a8 8 0 0 0 1.6 1.6m-33.4-30.8s1.2-2 4.3-1.2m12.2 15.8s1.9-7.8 8.4-5m-2.6-.6s.6-3.6-1-5.5m-3.5 5.2s.8 1.5 0 2.7"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#64b4d1",
    stroke: "#00247d",
    strokeMiterlimit: 2.6,
    strokeWidth: 1.2,
    d: "M423.5 341s7.4-3.3 5.2-9.1c0 0-.7-2-2.4-1.8 0 0-2.9.1-2.4 4 0 0 1 3.8-.5 7z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M426.2 337.6s1.6-1.5 1.4-4.3c0 0-.1-.6.1-.7 0 0 .4-.1.4.6 0 0 .5 2.9-1.5 4.5 0 0 0 .3-.3.2 0 0-.2 0-.1-.3z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#64b4d1",
    stroke: "#00247d",
    strokeMiterlimit: 2.6,
    strokeWidth: 1.2,
    d: "M434 335.8s5.3-3.2 2.4-8.7c0 0-.8-1.5-2.4-1.2 0 0-3.2 1-.7 5.5 0 0 1.2 2.9.7 4.5z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M435.4 328.4s-.3-.3 0-.6l.3.4s1.6 1.7.4 4.4c0 0-.2.4-.5.2v-.3s1.2-2.4-.2-4z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#64b4d1",
    stroke: "#00247d",
    strokeMiterlimit: 2.6,
    strokeWidth: 1.2,
    d: "M418.4 339.6s-5.8-1.4-4.7-7.5c0 0 .5-2.6 3-2.2 0 0 3 .8 1.1 4.6 0 0-1.2 2.6.6 5.1z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M416.2 332.5s-.2-.4 0-.5c0 0 .3 0 .4.2 0 0 .6 1 .2 2.4 0 0-.5.9-.3 1.8 0 0 0 .3-.2.4l-.3-.4s-.2-.8.3-1.8c0 0 .6-1.4 0-2.1z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M422.6 328.3s3.3-1.9 6 .3c0 0-.3-1.2-2.4-1.7 0 0-1.1-3.2-4.2-2.9 0 0 1.2 1.6 3 2.8 0 0-1.8.2-2.4 1.5zm2.4-8.7s2.4 1.7 3.2 2.8c0 0 .8-1.2 2-1.8 0 0-1.3-.3-2 .3 0 0-1.2-1-3.1-1.3z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "M412.1 326.6s-.2-.8.4-1.6c0 0 .3-.6.2-1.5m23.4-48s3.4-.2 4-3m6-1.8s-1.2 0-2.3 1.2c0 0-.8 1.2-2 1"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M431 265.2s1.7 0 2.7-.8c0 0 1-.7 1.7.4 0 0 1 1.6-.9 2.3 0 0-2.1 1.2 1.3 3.4 0 0-4.1-1.6-2.4-3.6 0 0 1.8-1.2 1.1-1.7 0 0-.2-.4-1 0-.7.6-2 .4-2.6 0z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#64b4d1",
    stroke: "#00247d",
    strokeMiterlimit: 2.6,
    strokeWidth: 1.2,
    d: "M433.3 221.6s.9-1.2.5-4.4 2.6-3.7 3.7-2.8c0 0 1.2 1 0 3.1a8.3 8.3 0 0 1-4.2 4.1z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M434.4 219s1.2-1.1.6-3.6l.1-.2h.4s.6 2.8-.6 4.2c0 0-.3.3-.5 0z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#64b4d1",
    stroke: "#00247d",
    strokeMiterlimit: 2.6,
    strokeWidth: 1.2,
    d: "M432.5 220.4s-.1-1.4-2.4-3.6c-2.4-2.4-.5-4.4 1-4.4 0 0 1.4 0 2 2.3a8.3 8.3 0 0 1-.6 5.7z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M432.1 217.4s0-1.6-2.1-3.3v-.4h.3s2.3 1.8 2.3 3.8c0 0 0 .3-.2.3 0 0-.3 0-.3-.4z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#64b4d1",
    stroke: "#00247d",
    strokeMiterlimit: 2.6,
    strokeWidth: 1.2,
    d: "M429.3 219.3s-.6-1-3.5-2.1c-2.8-1-2.1-3.5-1-4 0 0 1.4-.5 2.7 1.1a7.6 7.6 0 0 1 1.8 5z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M428 217.3s-.6-1.4-3.3-2.1c0 0-.2 0-.2-.3 0 0 0-.2.4-.1 0 0 2.8.6 3.7 2.4l-.2.3s-.2 0-.3-.2z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#64b4d1",
    stroke: "#00247d",
    strokeMiterlimit: 2.6,
    strokeWidth: 1.2,
    d: "M431 220.4s-1.3.5-4.4-1c-3-1.5-4.4 1.1-3.8 2.3 0 0 .5 1.6 2.9 1.2a8.3 8.3 0 0 0 5.4-2.4z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M424 221.4s1.3 1 3.8 0h.4s0 .2-.2.3c0 0-2.7 1.2-4.5.1 0 0-.2 0 0-.3h.4z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 1.2,
    d: "M426.6 210.7s1.5.8 1.2 2.5"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "M433.3 211s.6 1.9 0 3"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#64b4d1",
    stroke: "#00247d",
    strokeMiterlimit: 2.6,
    strokeWidth: 1.2,
    d: "M327.6 221.6s-.9-1.2-.5-4.4c.3-3.4-2.5-3.7-3.6-2.8 0 0-1.2 1-.1 3.1a8.3 8.3 0 0 0 4.2 4.1z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M326.5 219s-1-1.1-.6-3.6v-.2h-.5s-.5 2.8.7 4.2c0 0 .3.3.4 0z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#64b4d1",
    stroke: "#00247d",
    strokeMiterlimit: 2.6,
    strokeWidth: 1.2,
    d: "M328.5 220.4s0-1.4 2.4-3.6c2.4-2.4.5-4.4-1-4.4 0 0-1.5 0-2 2.3a8.3 8.3 0 0 0 .6 5.7z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M328.9 217.4s0-1.6 2-3.3c0 0 .2-.3 0-.4h-.2s-2.4 1.8-2.4 3.8c0 0 0 .3.3.3 0 0 .3 0 .3-.4z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#64b4d1",
    stroke: "#00247d",
    strokeMiterlimit: 2.6,
    strokeWidth: 1.2,
    d: "M331.6 219.3s.6-1 3.6-2.1c2.7-1 2-3.5.8-4 0 0-1.2-.5-2.6 1.1a7.6 7.6 0 0 0-1.8 5z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M333 217.3s.5-1.4 3.1-2.1c0 0 .3 0 .3-.3 0 0 0-.2-.3-.1 0 0-2.8.6-3.6 2.4v.3s.3 0 .4-.2z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#64b4d1",
    stroke: "#00247d",
    strokeMiterlimit: 2.6,
    strokeWidth: 1.2,
    d: "M329.8 220.4s1.5.5 4.4-1c3.1-1.5 4.5 1.1 4 2.3 0 0-.6 1.6-3 1.2a8.3 8.3 0 0 1-5.4-2.4z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M337 221.4s-1.3 1-4 0h-.2v.3s2.9 1.2 4.5.1c0 0 .3 0 0-.3h-.3z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 2.6,
    strokeWidth: 1.2,
    d: "M334.4 210.7s-1.6.8-1.2 2.5"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.2,
    d: "M327.6 211s-.6 1.9 0 3"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M394.1 193.6s1 2.7.6 5.2c-.4 2.4.1 2.9 1 3.4.7.3 2.3-.4 2.4-2.2 0 0 2 3.8-1.7 6.3 0 0-2.8 1.7-5-.4-.9-.9-1.2-3-.8-5 0 0 .6-2.7-.4-5.5 0 0 1.5 1.6 1.2 4.9 0 0-.9 6 3.5 5.6 0 0 3 0 3.1-3.6 0 0-1.2 1.2-2.5.8a2.4 2.4 0 0 1-1.8-2.8c.2-1.6.6-4.3.4-6.7zm-4.8 9.5s-.3 4.8-4.5 5.9c0 0 .6-.9-.4-3.3 0 0-1-1.2-1-3.3 0 0-1.1 1 .3 3.8 1 1.7.1 3.6-.1 3.7-.4.1 7-1 5.6-6.7zm-5.6-4.5s-1-1.2-1.2-3.8c0-2.7-.4-3.4-.8-3.6 0 0 .5 2.3.4 3.6 0 1.5 0 2.4.3 3 0 0-2.4.3-3.8-3-1.3-3.3-2.7-3-3.5-3 0 0 .9.1 2.4 3 1.7 3 2.2 3.7 6.2 3.7zm-10.7-7s1.2 3.2 1.3 4.8c0 0-3.1-1-4-3.5 0 0-3.2 1-2 4.7 0 0-2.8-1-4.1-3.2 0 0 1.5 1.2 3 1.7 0 0-.2-3.1 3.6-4.2 0 0 .6 2.7 2.7 3.3zm5-5.4s1.2 1.5 3.3 1.5a3.6 3.6 0 0 0 3.3-1.5s-.2 2.6-3.3 2.7c0 0-3.3 0-3.3-2.7zm-13.5 18.5 2 1.9s1.2 1.2 2-.3c0 0 1.4-2.4 3-2.2 0 0-1.3.7-2.4 3 0 0-.3.7-1.2.8-.5 0-1 .2-1.8-.7l-1.6-2.4zm16.7-29.4c-3.2 0-.5 2.4-.5 2.4 0 4-3 5.4-5.2 4.2-2.3-1.2-.5-4-.5-4s-2.4 1.5-1 3.9c1.6 2.4 5.8 1.2 7.2-.9 1.6 2.2 5.7 3.3 7.2.9 1.6-2.4-.9-4-.9-4s1.8 2.9-.4 4c-2.2 1.3-5.4 0-5.3-4 0 0 2.8-2.5-.5-2.5zm2-4.4s1.2 2 1 5c0 0 1-3-1-4.9zm-10 4.7s-.2-2.2-2.4-2.4c0 0 2 1.3 2.4 2.4zm16.1 0s.3-2.2 2.4-2.4c0 0-1.8 1.3-2.4 2.4zm-19.3 3.2s1.7.5 2.6-.7zm-5.4-13.1s2-.1 3.9 2.7c0 0-2 1-2.4 1.6 0 0 0-1 1-1.7 0 0-.4-1.4-2.5-2.5zm32 0s-2-.1-3.8 2.7c0 0 1.9 1 2.4 1.6 0 0 0-1-1-1.7 0 0 .4-1.4 2.4-2.5zm-14.7 2.2s1.7.5 3.8-.7c0 0 2.7-1.4 4.3 0 0 0-1.4-.7-4.3.7 0 0-2.7 1.6-3.8 0z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M383.7 169.6s1.5-2.5 6-2c0 0-1.2 3.6-6 2z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 386.7,
    cy: 168.8,
    fill: "#784421",
    rx: 0.8,
    ry: 1.1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 386.7,
    cy: 168.8,
    rx: 0.5,
    ry: 0.7
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M374.2 164.1s2.7.3 4.5 1.2c0 0 1.8 1.2 3.8-.3 0 0 2.3-1.4 3.7-3.1 0 0-3.4 2.3-4.7 2.7 0 0-1.2-1-1.6-2.3 0 0 .1-1 2-2.7 0 0-2.5.8-3 2.9a7.2 7.2 0 0 0 1.5 2.3s-.5.3-1.7-.6c0 0-2.7-.8-4.5 0zm7.1 17c-2.3 2.1 0 1.9 0 1.9s2.4.2 0-2zm-1.4-13.2s-1.8.5-4-.7c0 0-2.6-1.4-4.2 0 0 0 1.4-.7 4.3.7 0 0 2.8 1.6 4 0z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M378.1 169.6s-1.4-2.5-6-2c0 0 1.2 3.6 6 2z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 375,
    cy: 168.8,
    fill: "#784421",
    rx: 0.8,
    ry: 1.1
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 375,
    cy: 168.8,
    rx: 0.5,
    ry: 0.7
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M467.3 146.6v161.6c0 43.1-86.2 57.2-86.2 57.2s-86.3-14-86.3-57.2V146.6h172.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBm);
export default __webpack_public_path__ + "static/media/bm.b995edd9cec1ac342b6ca6ff191e2c16.svg";
export { ForwardRef as ReactComponent };